import {useEffect, useMemo, useState} from "react";
import useSWR from "swr";
import {fetcher} from "@/utils/utils";
import {BRANCH_UNIT_QUERY} from "@/pages/api/fragments";

const TYPE = 'allBranchUnits'

const query = `
	query getBranchUnits($state: ItemId) {
	  ${TYPE}(filter: { state: { eq: $state }}, first: 500, orderBy: name_ASC){
		${BRANCH_UNIT_QUERY}
	  }
	}
`

export default function useUnits(stateId='', disabled=false){
	const [allUnits, setAllUnits] = useState([])
	const requestBody =useMemo(() => {
		return ({
			query,
			variables: {
				"state": stateId
			}
		})
	},[stateId])
	const active = useMemo(() => {
		if(disabled) return false
		const exist = allUnits.some((item) => item.state === stateId)
		return !exist
	},[allUnits,stateId, disabled])


	const { data, isLoading,error } = useSWR(
		//fetch pages only if is active and currPage wasn't fetched already
		active ? ['/api/getData', requestBody] : null,
		fetcher
	);

	useEffect(() => {
		const newUnits = data?.data?.[TYPE] || []
		if(newUnits.length > 0){
			const items = { state: stateId, items: newUnits }
			setAllUnits((prevState) => {
				const exist = prevState.some((item) => item.state === stateId)
				if(exist) return prevState
				return ([...prevState, items])
			})
		}
	}, [data]);

	return {
		units: allUnits,
		isLoading
	}
}
